<template>
  <div style="width:100%">
    <div class="left-label mt-1">{{ metricItem.seleteItemLabel || metricItem.label || $t('scope.text_122') }}</div>
    <base-chart :chartData="chartData" :chartConfig="chartConfig" :chartSettings="chartSettings" :loading="loading" />
    <div class="right-label mb-2 pr-2">{{ $t('meter.res_cal_percent') }}</div>
  </div>
</template>

<script>
import { SUGGEST_RULE_METRIC } from '@Bill/constants'
export default {
  name: 'CdfChart',
  props: {
    measurement: String,
    field: String,
    eval_type: String,
    threshold: {
      type: Number,
      default: 1,
    },
  },
  data () {
    return {
      originData: [],
      // xAxis: [],
      // data: [],
    }
  },
  computed: {
    metricItem () {
      let metric = {}
      SUGGEST_RULE_METRIC.forEach(item => {
        item.metrics.forEach(m => {
          if (m.fromItem === this.measurement && m.seleteItem === this.field) {
            metric = m
          }
        })
      })
      return metric
    },
    markPoint () {
      const point = [0, 0]
      let idx = 0
      if (this.chartD.data.length) {
        this.chartD.data.forEach((data, index) => {
          if (Math.abs(data - this.threshold) < Math.abs(point[1] - this.threshold)) {
            point[1] = data
            idx = index
          }
        })
      }
      if (this.chartD.xAxis[idx]) {
        point[0] = this.chartD.xAxis[idx]
      }
      return point
    },
    chartData () {
      const chartData = {
        columns: [{}],
        rows: [{}],
      }
      return chartData
    },
    chartConfig () {
      return {
        height: '300px',
        width: '100%',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: '#CBDFF1',
            },
          },
        },
        grid: {
          top: 10,
          left: 10,
          right: 35,
          bottom: 10,
          containLabel: true,
          // borderColor: 'rgba(0, 0, 0, 0)',
          show: true,
        },
        legend: {
          show: false,
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false,
          },
          data: this.chartD.xAxis,
          axisLabel: {
            interval: 0,
            formatter: (val, index) => {
              if (index === this.chartD.xAxis.length - 1) {
                return Number(val) + this.metricItem.unit
              }
              return ''
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            formatter: (val, index) => {
              // if (index === 0) {
              //   return Number(val)
              // }
              // if (this.data.length && val === this.data[this.data.length - 1]) {
              return Number(val) + this.metricItem.unit
              // }
              // return ''
            },
          },
        },
        series: [
          {
            type: 'line',
            showSymbol: false,
            data: this.chartD.data,
          },
          {
            type: 'line',
            smooth: true,
            markLine: {
              symbol: 'none', // 隐藏标注线的箭头
              data: [ // 纵向标线
                [
                  { coord: [this.markPoint[0], 0], symbol: 'none' }, // 起点
                  { coord: [this.markPoint[0], this.markPoint[1]], symbol: 'none' }, // 终点
                ],
              ],
              lineStyle: {
                type: 'dashed',
                color: '#FF0000', // 设置标注线的颜色
              },
              label: {
                show: true,
                position: 'end',
                formatter: (params) => {
                  return `(${this.markPoint[0]}${this.metricItem.unit}, ${this.threshold})${this.metricItem.unit}`
                },
              },
            },
          },
          {
            type: 'line',
            smooth: true,
            markLine: {
              symbol: 'none', // 隐藏标注线的箭头
              data: [ // 横向标线
                [
                  { coord: [0, this.markPoint[1]], symbol: 'none' }, // 起点
                  { coord: [this.markPoint[0], this.markPoint[1]], symbol: 'none' }, // 终点
                ],
              ],
              lineStyle: {
                type: 'dashed',
                color: '#FF0000', // 设置标注线的颜色
              },
            },
          },
        ],
      }
    },
    chartD () {
      return this.genData(this.originData)
    },
  },
  watch: {
    measurement () {
      this.fetchChart()
    },
    field () {
      this.fetchChart()
    },
    eval_type () {
      this.fetchChart()
    },
  },
  created () {
    this.cM = new this.$Manager('unifiedmonitors/cdf-query', 'v1')
    this.fetchChart()
  },
  methods: {
    async fetchChart () {
      try {
        // if (!this.measurement || !this.field) {
        //   this.xAxis = []
        //   this.data = []
        //   return
        // }
        const res = await this.cM.list({
          params: {
            metric_name: `${this.measurement}.${this.field}`,
            period: '6h',
          },
        })
        this.originData = res.data?.data || []
        // this.genData(res.data.data)
      } catch (err) {
        throw err
      }
    },
    genData (list) {
      const xAxis = []
      const data = []
      const field = this.eval_type === '<' ? 'value_asc' : 'value_desc'
      list.forEach(item => {
        xAxis.push((item[field] / item.total * 100).toFixed(1))
        data.push(item.metric)
      })
      return { xAxis: this.eval_type === '<' ? xAxis : xAxis.reverse(), data: this.eval_type === '<' ? data : data.reverse() }
    },
  },
}
</script>

<style scoped>
.left-label {
  font-size: 12px;
}
.right-label {
  font-size: 12px;
  text-align: right;
}
</style>
